import ABCyaPhaser from "@abcya/abcya_phaser";

export default class FractionDisplay extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        this.workingWidth = 0;
        this.workingHeight = 0;
        this.txtHeight = 44;// Height of bitmap font
        this.fraction = null;
        this.txtNumerator = null;
        this.txtDenominator = null;
        this.line = null;

        this.txtNumerator = ABCyaPhaser.Images.addImage(0, 0, "1", this);
        this.txtDenominator = ABCyaPhaser.Images.addImage(0, 0, "8", this);
        this.line = ABCyaPhaser.Images.addImage(0, 0, "line", this);

        this.workingWidth = this.line.width;

        this.line.y = this.txtNumerator.height + 4;
        this.txtDenominator.y = this.line.y + this.line.height + 4;
    }

    reset(fraction) {
        this.fraction = fraction;
        this.txtNumerator.setFrame(this.fraction.numerator.toString());
        this.txtDenominator.setFrame(this.fraction.denominator.toString());

        this.line.y = Math.floor(this.txtNumerator.height + 4);
        this.txtDenominator.y = Math.floor(this.line.y + this.line.height + 4);

        this.txtNumerator.x = Math.floor(this.line.width / 2 - this.txtNumerator.width / 2);
        this.txtDenominator.x = Math.floor(this.line.width / 2 - this.txtDenominator.width / 2);

        this.workingWidth = Math.floor(this.line.width);//!! bigger fractions will need to max numbers & line
        this.workingHeight = Math.floor(this.txtDenominator.y + this.txtDenominator.height);
    }

    colorFraction(color) {
        if (color == null) {
            this.txtNumerator.clearTint();
            this.txtDenominator.clearTint();
            this.line.clearTint();
        } else {
            this.txtNumerator.setTintFill(color);
            this.txtDenominator.setTintFill(color);
            this.line.setTintFill(color);
        }
    }
}